export default () => ({
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  botName: {
    paddingLeft: 8
  }
});
